'use strict';

var _ = require('lodash');
var DeleteStrategyModalController = function DeleteStrategyModalController($scope, strategyListingService, strategiesService, hepService) {
  $scope.removeStrategies = function () {
    if (!_.isEmpty($scope.strategiesToRemove)) {
      var all = strategyListingService.removeStrategies($scope.strategiesToRemove);
      all.then(function () {
        strategiesService.retrieveTemplateUsage();
        $scope.$emit('grid:dataChanged');
      });
      $scope.strategiesToRemove = [];
    }
  };
  $scope.populateStrategiesToRemove = function (selectedRows) {
    $scope.strategiesToRemove = selectedRows;
  };
  $scope.strategyMaxDeleteCount = function () {
    return hepService.getSimpleHepProperties().MAX_DELETE_COUNT;
  };
};
DeleteStrategyModalController.$inject = ['$scope', 'StrategyListingService', 'StrategiesService', 'HepService'];
module.exports = DeleteStrategyModalController;